import { useState, useEffect, useRef } from 'react'

export function useDebouncedFetch<T>(
  fetchFn: (searchText: string) => Promise<T[]>,
  debounceMs = 1000
) {
  const [searchText, setSearchText] = useState('')
  const [options, setOptions] = useState<T[]>([])
  const [loading, setLoading] = useState(false)
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    setLoading(true)
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
    debounceTimeout.current = setTimeout(async () => {
      try {
        setOptions([])
        const results = await fetchFn(searchText)
        setOptions(results)
      } catch {
        setOptions([])
      } finally {
        setLoading(false)
      }
    }, debounceMs)
  }, [searchText])

  return { searchText, setSearchText, options, loading }
}
